class Navigation {
	constructor(options = {}) {
		this.breakpoint = options.breakpoint || 992
		this.menuToggle = document.querySelector(options.menuToggleSelector || ".menu-toggle")
		this.navLinks = document.querySelector(options.navLinksSelector || ".nav-links")
		this.overlay = document.querySelector(options.overlaySelector || ".mobile-overlay")
		this.navbar = document.querySelector(options.navbarSelector || ".navbar")
		this.resizeTimer = null

		this.init()
	}

	init() {
		if (!this.menuToggle || !this.navLinks) {
			return
		}

		this.menuToggle.addEventListener("click", () => this.toggleMenu())
		this.overlay?.addEventListener("click", () => this.closeMobileMenu())
		this.navLinks.addEventListener("click", event => this.handleMenuClick(event))
		document.addEventListener("keydown", event => this.handleKeydown(event))
		window.addEventListener("scroll", () => this.handleScroll(), { passive: true })
		window.addEventListener("resize", () => this.handleResize())

		this.handleScroll()
	}

	toggleMenu(forceClose = false) {
		const isOpen = this.menuToggle.getAttribute("aria-expanded") === "true"
		const shouldOpen = !isOpen && !forceClose

		this.menuToggle.setAttribute("aria-expanded", String(shouldOpen))
		this.navLinks.classList.toggle("is-active", shouldOpen)
		this.overlay?.classList.toggle("is-active", shouldOpen)
		document.body.classList.toggle("menu-is-open", shouldOpen)
		this.toggleMenuIcon(shouldOpen)
		this.toggleOverlay(shouldOpen)
	}

	closeMobileMenu() {
		this.toggleMenu(true)
	}

	toggleMenuIcon(isOpen) {
		const icon = this.menuToggle.querySelector("i")

		if (!icon) {
			return
		}

		icon.className = isOpen ? "fa-solid fa-xmark" : "fa-solid fa-bars"
	}

	toggleOverlay(isOpen) {
		if (!this.overlay) {
			return
		}

		if (isOpen) {
			this.overlay.removeAttribute("hidden")
			return
		}

		this.overlay.setAttribute("hidden", "")
	}

	handleMenuClick(event) {
		const clickedLink = event.target.closest("a")

		if (!clickedLink || !this.navLinks.contains(clickedLink)) {
			return
		}

		if (window.innerWidth > this.breakpoint) {
			return
		}

		const parentItem = clickedLink.closest(".menu-item-has-children")
		const parentLink = parentItem?.querySelector(":scope > a")
		const subMenu = parentItem?.querySelector(":scope > .sub-menu")
		const isParentDropdownLink = clickedLink === parentLink && subMenu

		if (!isParentDropdownLink) {
			this.closeMobileMenu()
			return
		}

		event.preventDefault()
		this.closeSiblingSubMenus(parentItem)
		this.toggleSubMenu(parentItem, subMenu)
	}

	toggleSubMenu(parentItem, subMenu) {
		const shouldOpen = !subMenu.classList.contains("is-active")

		subMenu.classList.toggle("is-active", shouldOpen)
		parentItem.classList.toggle("sub-menu-open", shouldOpen)
	}

	closeSiblingSubMenus(currentItem) {
		this.navLinks.querySelectorAll(".menu-item-has-children").forEach(item => {
			if (item === currentItem) {
				return
			}

			item.classList.remove("sub-menu-open")
			item.querySelector(":scope > .sub-menu")?.classList.remove("is-active")
		})
	}

	closeAllSubMenus() {
		this.navLinks.querySelectorAll(".menu-item-has-children").forEach(item => {
			item.classList.remove("sub-menu-open")
			item.querySelector(":scope > .sub-menu")?.classList.remove("is-active")
		})
	}

	handleKeydown(event) {
		if (event.key === "Escape" && this.navLinks.classList.contains("is-active")) {
			this.closeMobileMenu()
		}
	}

	handleScroll() {
		this.navbar?.classList.toggle("scrolled", window.scrollY > 50)
	}

	handleResize() {
		window.clearTimeout(this.resizeTimer)

		this.resizeTimer = window.setTimeout(() => {
			if (window.innerWidth <= this.breakpoint) {
				return
			}

			this.closeMobileMenu()
			this.closeAllSubMenus()
		}, 250)
	}
}

export default Navigation
